export const API_URL = 'https://sandbox-api.ticketmeta.io';
